export default {"src":"https://webcdn.trailways.com/_next/static/media/my-account.7d21df7b.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};